<template>
  <div class="container-fluid d-block d-md-flex flex-nowrap p-0">
    <loader v-show="formGroups.length === 0"></loader>
    <nav class="form-sidebar">
      <header>
        <h1 class="form-sidebar__title">
          <img src="@/assets/img/pdlb-logo-dark.png" class="img-fluid" alt="Les Pirates de la Bouffe">
          <span class="sr-only">Les Pirates de la Bouffe</span>
        </h1>
      </header>
      <ul class="list-unstyled form-sidebar__links">
        <li class="mb-md-4 position-relative">
          <strong>Offre pour le {{deliveryDay}}</strong>
        </li>
        <li v-for="formGroup in formGroups" :key="formGroup.slug" class="d-none d-md-block">
          <a :href="'#' + formGroup.slug"
             v-on:click.prevent="selectedCategory = formGroup.slug"
             class="form-sidebar__link"
             v-bind:class="{'active': selectedCategory === formGroup.slug}">
            {{formGroup.name}}
            <small class="form-sidebar__link-annot">({{formGroup.rows.length}})</small>
            <small class="ml-3">⭐ {{getSelectedFor(formGroup.name)}}</small>
          </a>
        </li>
      </ul>
    </nav>
    <div class="form-container flex-grow-1">
      <form class="container p-0 p-md-3">
        <select
            v-model="selectedCategory"
            v-on:change="categoryHandler()"
            name="category"
            id="category"
            class="custom-select category-menu__toggle-btn js-category-menu-toggle d-md-none">
          <option v-for="formGroup in formGroups" :key="formGroup.slug" :value="formGroup.slug">{{formGroup.name}}</option>
        </select>
        <table v-show="formGroup.slug === selectedCategory"
               :id="formGroup.slug"
               v-for="formGroup in formGroups"
               :key="formGroup.slug"
               class="table table-bordered text-left mb-3"
               v-bind:class="{'active': formGroup.slug === selectedCategory}">
          <thead class="thead-light">
            <tr>
              <th class="js-table-title"><h2 class="mb-0 d-none d-md-block">{{formGroup.name}}</h2></th>
              <th width="80">Prix</th>
              <th width="120">Q. désirée</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="formRow in formGroup.rows" :key="formRow.slug"
                :class="{'table-active': formRow.userValue !== ''}">
              <td :colspan="!formRow.price ? 3 : 1"
                  :class="{'col-single': !formRow.price}">
                {{formRow.name}} <span v-if="!formRow.price">&darr;</span>
                <small v-if="formRow.commentary !== ''" class="form-text text-muted">{{formRow.commentary}}</small>
              </td>
              <td v-if="formRow.price">
                <code class="table-price">{{formRow.price}}</code>
              </td>
              <td v-if="formRow.price">
                <label :for="formRow.slug" class="sr-only">Votre choix</label>
                <input v-model.lazy="formRow.userValue" type="text" class="form-control" :id="formRow.slug">
              </td>
            </tr>
          </tbody>
        </table>
      </form>
      <div class="floating-btn" v-show="selectedFromGroups.length > 0">
        <button type="submit" class="btn btn-primary"
                v-on:click.prevent="confirm">
          Visualiser ma sélection
          <span v-show="selectedFromGroups.length > 0" class="annotation">({{countSelectedItems}})</span>
        </button>
      </div>
    </div>
    <user-info-modal :shipping-option="shippingOption" v-if="userModalShown" v-on:hidden="userModalShown = false"></user-info-modal>
    <success-modal v-if="showSuccessModal"></success-modal>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import UserInfoModal from "@/components/UserInfoModal";
  import SuccessModal from "@/components/SuccessModal";
  import Loader from "@/components/Loader";
  import {isBetween} from "@/store/helper/dateCheck";

  export default {
    name: 'Form',
    components: {UserInfoModal, Loader, SuccessModal},
    data () {
      return {
        userModalShown: false,
        selectedCategory: '',
      }
    },
    watch: {
      formGroups (v) {
        if (v.length > 0) {
          this.selectedCategory = v[0].slug;
          this.$nextTick().then(() => {
            this.updateCategorySelectSize();
          });
        }
      }
    },
    computed: {
      shippingOption() {
        return this.currentSpreadsheet.shippingOption;
      },
      deliveryDay() {
        return this.currentSpreadsheet.deliveryDay;
      },
      ...mapGetters([
        'formGroups',
        'currentSpreadsheet',
        'showSuccessModal'
      ]),
      selectedFromGroups() {
        return this.$store.getters.selectedFormGroups(this.formGroups);
      },
      countSelectedItems () {
        return this.selectedFromGroups.reduce((count, group) => count + group.rows.length, 0);
      },
    },
    methods: {
      confirm () {
        this.userModalShown = true;
      },
      getSelectedFor(groupName) {
        const formGroup = this.selectedFromGroups.find(row => row.name === groupName);
        if (!formGroup) {
          return 0;
        }
        return formGroup.rows.length;
      },
      categoryHandler() {
        document.querySelector('#' + this.selectedCategory).scrollIntoView();
      },
      updateCategorySelectSize() {
        document.querySelector('.js-category-menu-toggle').style.width = document.querySelector('table.active .js-table-title').clientWidth + 'px';
      }
    },
    created() {
      const spreadsheetAccessibleRules = this.$store.getters.spreadsheetAccessibleRules(this.$route.params.id);
      if (!spreadsheetAccessibleRules ||
          !isBetween(spreadsheetAccessibleRules.from, spreadsheetAccessibleRules.to)) {
        this.$router.push(`/no-access/${this.$route.params.id}`);
      }

      this.$store.dispatch('setCurrentSpreadsheet', this.$route.params.id);
      this.$store.dispatch('fetchArticles', {
        spreadsheet: this.currentSpreadsheet,
        gapiClient: this.$gapi.getGapiClient
      });

      window.addEventListener('resize', this.updateCategorySelectSize)
    },
    destroyed() {
      window.removeEventListener('resize', this.updateCategorySelectSize)
    }
  }
</script>

<style scoped>
  .annotation {
    opacity: .66;
    font-size: .825em;
  }

  .col-single {
    font-weight: bold;
    font-size: 20px;
    background-color: #F4F4F4;
  }
</style>
